import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppPathPermissions } from '../constants/route-permissions.constant';
import { RightsEnum } from '../enums/rights.enum';
import { ScreensEnum } from '../enums/screens.enum';
import { UserPermissionsService } from './user-permissions.service';

@Injectable()
export class PermissionsService {

    constructor(private _perms: UserPermissionsService) {}
 
    //Returns true if a user has the given screen right permissions, false otherwise
    public hasPermission(screen: ScreensEnum, right: RightsEnum): boolean {
    //    console.log('HasPermission Called...');
        let userPerms = this._perms.getUserPermissions();
        if (userPerms != null) {
            let screenPerms = userPerms[screen];
            if (screenPerms != null) {
                return screenPerms.indexOf(right) !== -1;
            }
        }

        return false;
    }

    //Returns true if for the given screens the user has the given right for one of those screens, false otherwise
    public hasAtLeastOnePermission(screens: ScreensEnum[], right: RightsEnum): boolean {
        let userPerms = this._perms.getUserPermissions();
        if (userPerms != null) {
            for (let screen of screens) {
                let screenPerms = userPerms[screen];

                if (screenPerms != null && screenPerms.indexOf(right) !== -1) {
                    return true;
                }
            }
        }

        return false;
    }

    //Returns true if for a given screen the user has one of the given rights, false otherwise
    public hasAtLeastOneRight(screen: ScreensEnum, rights: RightsEnum[]) {
        let userPerms = this._perms.getUserPermissions();
        if (userPerms != null) {
            let screenPerms = userPerms[screen];

            if (screenPerms != null) {
                for (let right of rights) {
                    if (screenPerms.indexOf(right) !== -1) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    //Checks if the user is authorized at the given url
    public canActivate(url: string): boolean {
        //Load the screen and right permissions for the url
        let perms = AppPathPermissions[url];

        if (perms != null) {
            //If we have a screen and right for the url check if the user has permissions
            return this.hasPermission(perms.screen, perms.right);
        } else {
            //We don't have right or permissions at the given url
            //We need to add it to our screen right permission constant
            return false;
        }
    }

    //Returns the users full name
    public getUserName(): string {
        return this._perms.getUserName();
    }

    public getUser511(): string {
        return this._perms.getUser511();
    }

    //Returns true if the auth call has completed
    public havePermsLoaded(): boolean {
        return this._perms.havePermsLoaded();
    }

    //Returns the auth call so we can subscribe until it completes
    public getAuthSub(): Observable<{} | Response> {
        return this._perms.getAuthSub();
    }

    public arePermissionsValid(): boolean {
        return this._perms.getUserPermissions() != null;
    }
}